import objectPath from 'object-path'
import cloneDeep from 'clone-deep'
import PNotify from 'pnotify/dist/es/PNotify'
import { generateString } from 'designer/component/action/Data'
import {
  basicElement,
  convertElementSchema,
  isFormData,
  systemElement,
} from 'designer/component/system/menu/formElements/data/element'
import {
  formSchema,
  formUischema,
  pageSchema,
  pageUischema,
  widgetSchema,
  widgetUischema,
} from 'designer/component/action/Schema'
import {
  convertContainerSchema,
  staticContainer,
  staticSubContainer,
  tabContainer,
} from 'designer/component/system/menu/formElements/data/container'
import Swal from 'sweetalert2'
import moment from 'moment'
import httpClient from 'utility/httpClient.util'
import { ROUTE_HIS } from 'designer/component/action/Config'
import { cleanJsonFormRuntimeData } from 'designer/component/action/Publish'

export const DESIGNER_TYPE = ['Form', 'Page', 'Widget']

export const makeUppercaseFirst = (item = '') => {
  return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
}

export const renderUi = (props, template) => {
  const { design, setDesign, setJsonForm, uischema, schema, data } = props
  if (
    schema &&
    isJsonString(schema, 'Schema') &&
    uischema &&
    isJsonString(uischema, 'Uischema')
  ) {
    let renderSchema = JSON.parse(schema)
    let renderUischema = JSON.parse(uischema)
    let renderData = {}
    if (isJsonString(data, 'Data', false)) {
      renderData = JSON.parse(data)
    }
    setJsonForm({
      schema: renderSchema,
      uischema: renderUischema,
      data: renderData,
    })
    if (!template || template.length === 0) {
      template = createTemplateConvert(props, renderSchema, renderUischema)
    }
    createDesignConvert(props, template)
  } else {
    setJsonForm({
      schema: {},
      uischema: {},
    })
    setDesign({
      ...design,
      schema: {},
      uischema: {},
    })
  }
}

export const isJsonString = (str, title, isAlertNotice = true) => {
  try {
    JSON.parse(str)
  } catch (e) {
    if (isAlertNotice) {
      let notice = PNotify.error({
        title: `${title} : ${e.name}`,
        text: e.message,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
    }
    return false
  }
  return true
}

export const checkPropertiesList = (properties, mainItemTemplate, template) => {
  Object.keys(properties).forEach((scopeName) => {
    let propObj = properties[scopeName]
    let title = scopeName.split('_')
    let newTitle = []
    title.map((value) => {
      value = makeUppercaseFirst(value)
      newTitle.push(value)
    })

    let joinTitle = newTitle.join(' ')
    let tagname = checkControlSchemaType(propObj)
    let itemTemplate = {
      uiType: 'element',
      type: 'Control',
      name: scopeName,
      title: joinTitle,
      label: joinTitle,
      key: tagname + generateString(5),
      scope: '#/properties/' + scopeName + '/' + tagname,
      fieldName: joinTitle,
      schemaType: propObj.type,
      convertType: tagname,
      tagname: tagname,
      group: {
        label: mainItemTemplate.fieldName,
        type: 'Group',
        scopeName: mainItemTemplate.name,
        key: mainItemTemplate.key,
      },
    }
    console.log('checkPropertiesList', itemTemplate)
    template.push(itemTemplate)
  })
  return template
}

export const createDynamicPanel = (items, mainItemTemplate, template) => {
  let scopeName = mainItemTemplate.name + 'Panel'
  let tagname = 'dynamicPanel'
  let title = mainItemTemplate.title
  let key = tagname + generateString(5)
  let itemTemplate = {
    uiType: 'container',
    type: 'Group',
    name: scopeName,
    key: key,
    scope: '#/properties/' + scopeName + '/' + tagname,
    fieldName: title,
    title: title,
    label: '',
    schemaType: 'object',
    convertType: tagname,
    tagname: tagname,
    group: {
      label: title,
      type: 'Group',
      scopeName: mainItemTemplate.name,
      fullKey: mainItemTemplate.fullKey,
      key: mainItemTemplate.key,
    },
  }
  console.log('createDynamicPanel', {
    items,
    itemTemplate,
    mainItemTemplate,
  })
  template.push(itemTemplate)
  template = checkPropertiesList(items.properties, itemTemplate, template)
  return template
}

export const checkChildElement = (
  element,
  schema,
  schemaProperties,
  mainItemTemplate,
  template
) => {
  if (!mainItemTemplate) return template
  let { tagname } = mainItemTemplate

  if (tagname === 'tab') {
    let { anyOf } = schemaProperties
    let { elements } = element
    if (anyOf) {
      anyOf.forEach((item) => {
        let refKey = item[`$ref`].replace('#/', '').split('/')
        let { properties, title } = objectPath.get(schema, refKey)
        let tagname = 'tabPanel'
        let scopeKey = tagname + generateString(5)
        let itemTemplate = {
          uiType: 'container',
          type: 'Group',
          name: scopeKey,
          key: scopeKey,
          scope: '#/properties/' + scopeKey + '/' + tagname,
          fieldName: title,
          title: title,
          label: '',
          schemaType: 'object',
          convertType: tagname,
          tagname: tagname,
          group: {
            label: element.label,
            type: 'Group',
            scopeName: mainItemTemplate.name,
            fullKey: mainItemTemplate.fullKey,
            key: mainItemTemplate.key,
          },
          tabPanelKey: `${mainItemTemplate.fullKey}.${scopeKey}`,
        }
        template.push(itemTemplate)
        template = checkPropertiesList(properties, itemTemplate, template)
      })
    } else if (element.type === 'Category' && elements) {
      let label = element.label
      let scope = elements[0].scope
      let refKey = scope.replace('#/', '').split('/')
      let properties = objectPath.get(schema, refKey)
      let scopeName = refKey.pop()
      let tagname = 'tabPanel'
      let key = tagname + generateString(5)
      let itemTemplate = {
        uiType: 'container',
        type: 'Group',
        name: scopeName,
        key: key,
        scope: '#/properties/' + scopeName + '/' + tagname,
        fieldName: label,
        title: label,
        label: '',
        schemaType: 'object',
        convertType: tagname,
        tagname: tagname,
        group: {
          label: label,
          type: 'Group',
          scopeName: mainItemTemplate.name,
          fullKey: mainItemTemplate.fullKey,
          key: mainItemTemplate.key,
        },
        tabPanelKey: `${mainItemTemplate.fullKey}.${key}`,
      }
      template.push(itemTemplate)
      if (properties.type === 'array') {
        let { items } = properties
        let tagname = 'dynamic'
        let key = tagname + generateString(5)
        let label = element.label
        let name = ''
        if (label) {
          name = label.toLowerCase().replace(' ', '_')
        } else {
          name = generateString(5)
        }
        let scopeName = name + makeUppercaseFirst(tagname)
        let itemArrayTemplate = {
          uiType: 'container',
          type: 'Group',
          name: scopeName,
          key: key,
          scope: '#/properties/' + scopeName + '/' + tagname,
          fieldName: label,
          title: label,
          label: '',
          schemaType: 'object',
          convertType: tagname,
          tagname: tagname,
          group: {
            label: label,
            type: 'Group',
            scopeName: itemTemplate.name,
            fullKey: itemTemplate.fullKey,
            key: itemTemplate.key,
          },
        }
        console.log('checkChildElement', {
          tagname,
          properties,
          element,
          itemArrayTemplate,
        })
        template.push(itemArrayTemplate)
        template = createDynamicPanel(items, itemArrayTemplate, template)
        //template = checkPropertiesList(items.properties, itemTemplate, template)
      } else if (properties.type === 'object') {
        template = checkPropertiesList(properties, itemTemplate, template)
      }
    }
  }
  return template
}

export const checkElementTag = (schemaProperties, itemTemplate) => {
  let tagname = itemTemplate.convertType
  if (tagname === 'select') {
    let options = []
    let keyOptions = []
    let optionLabel = 'label'
    let optionValue = 'value'
    if (schemaProperties?.enum) {
      let selectList = schemaProperties.enum
      selectList.forEach((value) =>
        options.push({
          label: value,
          value: value,
        })
      )
      keyOptions = [
        { label: 'label', value: 'label' },
        { label: 'value', value: 'value' },
      ]
    }
    if (schemaProperties?.oneOf) {
      options = schemaProperties.oneOf
      let firstOption = options[0]
      if (firstOption) {
        Object.keys(firstOption).forEach((key) => {
          keyOptions.push({ label: key, value: key })
        })
        optionLabel = Object.keys(firstOption)[0]
        optionValue = Object.keys(firstOption)[0]
      }
    }
    itemTemplate = {
      ...itemTemplate,
      optionType: 'custom',
      custom: {
        options: options,
        keyOptions: keyOptions,
        optionLabel: optionLabel,
        optionValue: optionValue,
      },
    }
  } else if (tagname === 'checkbox') {
    itemTemplate = {
      ...itemTemplate,
      checkboxText: itemTemplate.label,
      label: '',
    }
  } else if (tagname === 'table') {
    let { columns } = itemTemplate?.options || {}
    let tableSchema = schemaProperties?.items?.properties
    let tableColumn = []
    let column = {
      type: 'string',
      value: '',
      mapKey: '',
      editable: 'always',
      maxWidth: 'auto',
      minWidth: 'auto',
      position: '',
      textAlign: 'left',
      typeField: 'string',
      valueType: 'receive',
      receiveData: '',
    }
    if (columns) {
      columns.forEach(({ label, scope = '' }) => {
        let scopeKey = scope.replace('#/', '').split('/')
        let field = scopeKey.pop()
        column = {
          ...column,
          field: field,
          title: label,
        }
        tableColumn.push(column)
      })
    }
    if (tableSchema) {
      Object.keys(tableSchema).forEach((key) => {
        let { type, title } = tableSchema[key]
        column = {
          ...column,
          type,
          title,
          field: key.toLocaleLowerCase(),
        }
        tableColumn.push(column)
      })
    }

    console.log('checkElementTag', { itemTemplate, schemaProperties })
    itemTemplate = {
      ...itemTemplate,
      tableColumn: tableColumn,
    }
    objectPath.del(itemTemplate, 'options')
  } else if (tagname === 'tab') {
    itemTemplate = {
      ...itemTemplate,
      type: 'Group',
      uiType: 'container',
    }
  }
  return {
    ...itemTemplate,
    scope: '#/properties/' + itemTemplate.name + '/' + tagname,
    tagname: tagname,
  }
}

export const checkControlSchemaType = (schemaProperties, element = {}) => {
  if (schemaProperties.type === 'string') {
    if (schemaProperties.enum) {
      return objectPath.get(convertElementSchema, 'enum')
    }
    if (schemaProperties.format) {
      return objectPath.get(convertElementSchema, schemaProperties.format)
    }
    if (schemaProperties.oneOf) {
      return objectPath.get(convertElementSchema, 'oneOf')
    }
  }
  if (schemaProperties.anyOf) {
    return objectPath.get(convertContainerSchema, 'tab')
  }
  if (element.options) {
    let { layout } = element.options
    if (layout) {
      return objectPath.get(convertContainerSchema, layout.toLowerCase())
    }
  }
  return objectPath.get(convertElementSchema, [schemaProperties.type])
}

export const camelToFlat = (camel) => {
  const camelCase = camel.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ')
  let flat = ''
  camelCase.forEach((word) => {
    flat = flat + word.charAt(0).toUpperCase() + word.slice(1) + ' '
  })
  return flat
}

export const checkElements = (elements, schema, template, mapping, group) => {
  elements.forEach((item) => {
    let subType = item.type
    let subElements = item.elements
    if (subType === 'Group') {
      let tagname = 'card'
      let scopeName = ''
      if (item.label) {
        scopeName = item.label.toLowerCase().replace(' ', '_')
      } else {
        scopeName = tagname + generateString(5)
      }
      template.push({
        uiType: 'container',
        type: item.type,
        title: item.label,
        scope: '#/properties/' + scopeName + '/card',
        name: scopeName,
        tagname: 'card',
        schemaType: 'object',
        convertType: 'object',
      })
      checkElements(subElements, schema, template, mapping, {
        label: item.label,
        type: item.type,
        scopeName,
      })
    } else if (subType === 'HorizontalLayout' || subType === 'VerticalLayout') {
      checkElements(subElements, schema, template, mapping, group)
    } else if (subType === 'Button') {
      let tagname = 'button'
      let scopeName = tagname + generateString(5)
      let title = item.label
      let itemTemplate = {
        uiType: 'element',
        type: subType,
        name: scopeName,
        title: title,
        label: title,
        fieldName: title,
        schemaType: 'object',
        convertType: tagname,
        scope: '#/properties/' + scopeName + '/' + tagname,
        tagname: tagname,
      }
      template.push(itemTemplate)
    } else if (
      subType === 'Control' ||
      subType === 'Table' ||
      subType === 'TableControl'
    ) {
      let subScope = item.scope
      let scopeKey = subScope.replace('#/', '').split('/')
      let schemaProperties = objectPath.get(schema, scopeKey) || {}
      let scopeName = scopeKey.pop()
      let title = schemaProperties.title
      if (!title) {
        title = camelToFlat(scopeName)
      }
      let itemTemplate = {
        uiType: 'element',
        type: subType,
        name: scopeName,
        title: title,
        label: title,
        fieldName: title,
        schemaType: schemaProperties.type,
        convertType: checkControlSchemaType(schemaProperties, item),
      }
      if (item.options) {
        objectPath.set(itemTemplate, 'options', item.options)
      }
      if (group) {
        objectPath.set(itemTemplate, 'group', group)
      }
      itemTemplate = checkElementTag(schemaProperties, itemTemplate)
      template.push(itemTemplate)
      template = checkChildElement(
        item,
        schema,
        schemaProperties,
        itemTemplate,
        template
      )
    } else if (subType === 'Category') {
      let title = ''
      let scopeName = ''
      if (item.label) {
        title = item.label
        scopeName = camelToFlat(item.label)
      }
      let itemTemplate = {
        uiType: 'element',
        type: subType,
        name: scopeName,
        title: title,
        label: title,
        fieldName: title,
        schemaType: 'object',
        convertType: 'tab',
      }
      template.push(itemTemplate)
      console.log('checkElements', { item, itemTemplate })
      template = checkChildElement(item, schema, {}, group, template)
    }
  })
}

export const createTemplateConvert = (props, schema, uischema) => {
  let { setTemplate } = props
  let { type, elements = [] } = uischema
  let template = []
  let mapping = {
    mapField: {},
    mapFormData: {},
    mapKey: {},
    mapName: {},
    mapTag: {},
  }
  if (type === 'Categorization') {
    let tagname = 'tab'
    let scopeName = tagname + generateString(5)
    let itemTemplate = {
      uiType: 'container',
      type: 'Group',
      title: makeUppercaseFirst(tagname),
      scope: '#/properties/' + scopeName + '/tab',
      name: scopeName,
      key: scopeName,
      tagname: tagname,
      schemaType: 'object',
      convertType: tagname,
    }
    template.push(itemTemplate)
    checkElements(elements, schema, template, mapping, {
      ...itemTemplate,
      scopeName,
    })
  } else {
    checkElements(elements, schema, template, mapping)
  }

  console.log('createTemplateConvert', { schema, elements, template })
  setTemplate(template)
  return template
}

export const createDesignConvert = (props, template) => {
  const { design, setDesign } = props
  let designType = design?.type
  if (!designType) return
  let newDesign = design
  if (designType === 'Form') {
    newDesign = createFormDesign(props, template)
  } else if (designType === 'Page') {
    newDesign = createPageDesign(props, template)
  } else if (designType === 'Widget') {
    newDesign = createWidgetDesign(props, template)
  }
  console.log('createDesignConvert', newDesign)
  setDesign(newDesign)
  return newDesign
}

export const findUischemaIndex = (currentKey, mapKey, elements) => {
  let indexList = []
  let newElements = elements
  if (mapKey) {
    let listKey = mapKey.split('.')
    listKey.forEach((key, i, arr) => {
      let index = newElements.findIndex((element) => element.key === key)
      let element = objectPath.get(newElements, [index, 'elements'])
      if (element) {
        newElements = element
        indexList = [...indexList, index]
      }
      if (key === currentKey) {
        arr.length = i + 1
      }
    })
    return indexList
  }
  return []
}

export const findUiSchema = (elements, indices) => {
  let newElements = indices.reduce(
    (o, i) => objectPath.get(o, ['elements', i]),
    { elements }
  )
  return newElements
}

export const createMapping = (item, mapping, layout) => {
  let { group, label, type, tagname, name, title, checkboxText } = item
  let key = item.key
  if (!key) {
    key = tagname + generateString(5)
  }
  let fieldName = label || title || checkboxText
  objectPath.set(mapping, `mapField.${key}`, fieldName)
  objectPath.set(
    mapping,
    `mapFormData.${key}`,
    objectPath.get(isFormData, tagname)
  )
  objectPath.set(mapping, `mapTag.${key}`, tagname)

  let fullName = ''
  let fullKey = ''
  if (group) {
    let groupFullName = objectPath.get(
      mapping,
      `groupFullName.${group.scopeName}`
    )
    let groupFullKey = objectPath.get(
      mapping,
      `groupFullKey.${group.scopeName}`
    )
    let groupKey = objectPath.get(mapping, `groupKey.${group.scopeName}`)
    fullName = [groupFullName, name].join('.')
    fullKey = [groupFullKey, key].join('.')
    objectPath.set(item, 'group.fullKey', groupFullKey)
    objectPath.set(item, 'group.key', groupKey)
  } else {
    fullName = [layout, name].join('.')
    fullKey = [layout, key].join('.')
  }
  objectPath.set(mapping, `mapName.${key}`, fullName)
  objectPath.set(mapping, `mapKey.${key}`, fullKey)
  if (type === 'Group') {
    objectPath.set(mapping, `groupFullKey.${name}`, fullKey)
    objectPath.set(mapping, `groupFullName.${name}`, fullName)
    objectPath.set(mapping, `groupKey.${name}`, key)
  }
  objectPath.set(item, 'key', key)
  objectPath.set(item, 'fullName', fullName)
  objectPath.set(item, 'fullKey', fullKey)
  return item
}

export const getDataUi = (layout, item, result, found, subGroup = false) => {
  const { destination } = result
  if (!found) return
  let dataUi = {
    ...found.uischema,
    ...item,
    index: destination.index,
    tagname: found.id,
    subGroup: subGroup,
    layout: layout,
    isShowUi: true,
    isShowField: true,
    elements: [],
  }
  return { dataUi: dataUi }
}

export const getLayoutIndices = (layoutKey, elements) => {
  let layoutIndices = findUischemaIndex(layoutKey, layoutKey, elements)
  return layoutIndices
}

export const addUiSchema = (elements, destinationIndex, indices, value) => {
  let newElements = findUiSchema(elements, indices)
  newElements = newElements.elements
  newElements.splice(destinationIndex, 0, value)
  newElements.map((value, i) => (value.index = i))
  return newElements
}

export const addUiForLayout = (result, item, { dataUi }, uiElements) => {
  let layoutKey = objectPath.get(result, 'destination.droppableId')
  let layoutIndex = objectPath.get(result, 'destination.index')
  let layoutIndices = getLayoutIndices(layoutKey, uiElements)
  objectPath.del(dataUi, 'part')
  let newElements = addUiSchema(uiElements, layoutIndex, layoutIndices, dataUi)
  return newElements
}

export const addUiForContainer = (result, item, { dataUi }, uiElements) => {
  let containerKey = objectPath.get(result, 'destination.droppableId')
  let containerIndex = objectPath.get(result, 'destination.index')
  let mapKey = item?.group?.fullKey
  let containerIndices = findUischemaIndex(containerKey, mapKey, uiElements)
  objectPath.del(dataUi, 'part')
  let newElements = addUiSchema(
    uiElements,
    containerIndex,
    containerIndices,
    dataUi
  )
  return newElements
}

export const createDesign = async (result, item, uiElements) => {
  let subGroup = false
  const { destination, draggableId, source } = result
  let layoutKey = destination.droppableId
  if (
    !destination ||
    destination.droppableId === 'element' ||
    destination.droppableId === 'container'
  )
    return
  if (
    destination.droppableId === 'header' ||
    destination.droppableId === 'body' ||
    destination.droppableId === 'footer'
  ) {
    if (source.droppableId === 'container') {
      let staticContainers = staticContainer.concat(staticSubContainer)
      let found = staticContainers.find(({ id }) => id === draggableId)
      let dataLayout = getDataUi(layoutKey, item, result, found)
      uiElements = addUiForLayout(result, item, dataLayout, uiElements)
    } else if (source.droppableId === 'element') {
      let staticElements = basicElement.concat(systemElement)
      let found = staticElements.find(({ id }) => id === draggableId)
      let dataLayout = getDataUi(layoutKey, item, result, found)
      uiElements = addUiForLayout(result, item, dataLayout, uiElements)
    }
  } else {
    if (source.droppableId === 'container') {
      let staticContainers = staticContainer.concat(staticSubContainer)
      let found = staticContainers.find(({ id }) => id === draggableId)
      let dataLayout = getDataUi(layoutKey, item, result, found, !subGroup)
      uiElements = addUiForContainer(result, item, dataLayout, uiElements)
    } else if (source.droppableId === 'element') {
      let staticElements = basicElement.concat(systemElement)
      let found = staticElements.find(({ id }) => id === draggableId)
      let dataLayout = getDataUi(layoutKey, item, result, found)
      uiElements = addUiForContainer(result, item, dataLayout, uiElements)
    }
  }

  return uiElements
}

export const createUi = (item, layout, uiElements, index) => {
  let source = null
  let staticContainers = staticContainer.concat(staticSubContainer)
  let containerIndex = staticContainers.findIndex(
    ({ id }) => id === item.tagname
  )
  let staticElements = basicElement.concat(systemElement)
  let elementIndex = staticElements.findIndex(({ id }) => id === item.tagname)
  if (containerIndex > -1) {
    source = {
      index: containerIndex,
      droppableId: 'container',
    }
  }
  if (elementIndex > -1) {
    source = {
      index: elementIndex,
      droppableId: 'element',
    }
  }
  if (!source) return
  let droppableId = item?.group?.key || layout
  let result = {
    draggableId: item.tagname,
    type: 'DEFAULT',
    source: source,
    reason: 'DROP',
    mode: 'FLUID',
    destination: {
      droppableId: droppableId,
      index: index,
    },
    combine: null,
  }
  uiElements = createDesign(result, item, uiElements)
  return uiElements
}

const SUPPORTED_SCHEMA_FORMATS = [
  'data-url',
  'date',
  'date-time',
  'email',
  'hostname',
  'ipv4',
  'ipv6',
  'uri',
]

export const checkFormatJsonSchema = (schema) => {
  if (schema.type === 'object') {
    let { properties } = schema
    Object.keys(properties).forEach((key) => {
      let itemSchema = properties[key]
      let { format } = itemSchema
      if (format) {
        if (SUPPORTED_SCHEMA_FORMATS.includes(format)) {
          objectPath.del(schema, ['properties', key, 'format'])
        }
      }
    })
  }
  return schema
}

export const createSchema = (item, mapping) => {
  let properties = mapping?.properties || {}
  let { fullName } = item
  let nameList = fullName.split('.')
  let addKey = []
  nameList.forEach((name, index) => {
    let isLast = nameList.length - 1 === index
    if (isLast) {
      addKey.push(name)
      objectPath.set(properties, addKey, {
        type: item.schemaType,
      })
    } else {
      addKey.push(name)
      let subProperties =
        objectPath.get(properties, [...addKey, 'properties']) || {}
      objectPath.set(properties, addKey, {
        properties: subProperties,
        type: 'object',
      })
      addKey.push('properties')
    }
  })
  objectPath.set(mapping, `properties`, properties)
}

export const createFormDesign = (props, template) => {
  const { design, setMapping } = props
  let designSchema = cloneDeep(formSchema)
  let designUischema = cloneDeep(formUischema)
  let mapping = {}
  let uiElements = designUischema.elements
  let layout = objectPath.get(uiElements, `0.name`)
  template.map((item, index) => {
    item = createMapping(item, mapping, layout)
    createUi(item, layout, uiElements, index)
    createSchema(item, mapping)
  })
  setMapping(mapping)
  objectPath.set(designSchema, 'mapField', mapping.mapField)
  objectPath.set(designSchema, 'mapFormData', mapping.mapFormData)
  objectPath.set(designSchema, 'mapKey', mapping.mapKey)
  objectPath.set(designSchema, 'mapName', mapping.mapName)
  objectPath.set(designSchema, 'mapTag', mapping.mapTag)
  objectPath.set(designSchema, 'properties', mapping.properties)
  return {
    ...design,
    schema: designSchema,
    uischema: designUischema,
  }
}

export const createPageDesign = (props, template) => {
  const { design, setMapping } = props
  let designSchema = cloneDeep(pageSchema)
  let designUischema = cloneDeep(pageUischema)
  let mapping = {}
  let uiElements = designUischema.elements
  let layout = objectPath.get(uiElements, `0.name`)
  template.map((item, index) => {
    if (item.tagname === 'table') {
      layout = objectPath.get(uiElements, `1.name`)
    }
    item = createMapping(item, mapping, layout)
    createUi(item, layout, uiElements, index)
    createSchema(item, mapping)
  })
  setMapping(mapping)
  objectPath.set(designSchema, 'mapField', mapping.mapField)
  objectPath.set(designSchema, 'mapFormData', mapping.mapFormData)
  objectPath.set(designSchema, 'mapKey', mapping.mapKey)
  objectPath.set(designSchema, 'mapName', mapping.mapName)
  objectPath.set(designSchema, 'mapTag', mapping.mapTag)
  objectPath.set(designSchema, 'properties', mapping.properties)
  return {
    ...design,
    schema: designSchema,
    uischema: designUischema,
  }
}

export const createWidgetDesign = (props, template) => {
  const { design, setMapping } = props
  let designSchema = cloneDeep(widgetSchema)
  let designUischema = cloneDeep(widgetUischema)
  let mapping = {}
  let uiElements = designUischema.elements
  let layout = objectPath.get(uiElements, `0.name`)
  template.map((item, index) => {
    item = createMapping(item, mapping, layout)
    createUi(item, layout, uiElements, index)
    createSchema(item, mapping)
  })
  setMapping(mapping)
  objectPath.set(designSchema, 'mapField', mapping.mapField)
  objectPath.set(designSchema, 'mapFormData', mapping.mapFormData)
  objectPath.set(designSchema, 'mapKey', mapping.mapKey)
  objectPath.set(designSchema, 'mapName', mapping.mapName)
  objectPath.set(designSchema, 'mapTag', mapping.mapTag)
  objectPath.set(designSchema, 'properties', mapping.properties)
  return {
    ...design,
    schema: designSchema,
    uischema: designUischema,
  }
}

export const createDesignerCode = (props) => {
  const { design, setDesign } = props
  const { type } = design
  objectPath.set(design, 'enable', true)
  let request = {
    code: design.formCode,
    name: design.formName,
    jsonData: design,
    isEnabled: design.enable === true ? 1 : 0,
  }

  if (type === 'Form') {
    request = {
      ...request,
      formModuleId: design.formModuleId,
      module: design.module,
      isPage: 0,
      isWidget: 0,
    }
  } else if (type === 'Page') {
    request = {
      ...request,
      formModuleId: design.formModuleId,
      module: design.module,
      isPage: 1,
      isWidget: 0,
    }
  } else if (type === 'Widget') {
    request = {
      ...request,
      formModuleId: design.formWidgetGroupId,
      isPage: 0,
      isWidget: 1,
    }
  }
  saveToDesigner(design, request)
  setDesign(design)
}

const saveToDesigner = async (design, request) => {
  if (design.type === 'Widget') {
    if (!design.formWidgetGroupId) {
      errorNoti('กรุณาเลือก Category')
      return
    }
  }
  if (design.type === 'Form' || design.type === 'Page') {
    if (!design.formModuleId) {
      errorNoti('กรุณาเลือก Module')
      return
    }
  }
  if (!design.formName) {
    errorNoti(`กรุณากรอก ${design.type} Name`)
    return
  }
  if (!design.formCode) {
    errorNoti(`กรุณากรอก ${design.type} Code`)
    return
  }

  objectPath.set(request, 'formWidget', {
    name: design.formName,
    formWidgetGroupId: design.formWidgetGroupId,
  })
  objectPath.set(request, 'jsonData.props.system', {
    name: 'system',
    props: {
      pageCode: {
        prop: 'pageCode',
        value: design.formCode,
        propType: 'system',
      },
    },
  })

  let formRevision = createRevision(null)
  request = {
    ...request,
    ...formRevision,
  }
  await httpClient
    .post(`/designer/form-design`, request)
    .then(({ data }) => {
      let formDesign = data.data
      successNoti(design.type, formDesign)
    })
    .catch((error) => errorNoti(error))
}

const createRevision = async (design = {}) => {
  let revisionDesign = cleanJsonFormRuntimeData(design)
  let latestSubVersion = 0
  let restoreVersion = 0
  let note = ''
  if (restoreVersion && restoreVersion !== 0) {
    note = `created from version ${restoreVersion}`
  }
  let subVersion = latestSubVersion + 1
  let formRevision = {
    formDesignId: null,
    subVersion: subVersion,
    version: '',
    note: note,
    createdAt: moment().format(),
    isOfficial: 0,
    jsonData: {
      schema: revisionDesign?.schema,
      uischema: revisionDesign?.uischema,
      collection: {},
      customGroup: {},
      tableGroup: {},
      require: {},
      validation: {},
      formGroup: {},
    },
  }
  return await httpClient
    .post(`/designer/form-revision`, formRevision)
    .then(({ data }) => data.data)
    .catch(() => {})
}

const successNoti = (type, { name, code }) => {
  let designerType = type.toLowerCase()
  Swal.fire({
    icon: 'success',
    title: `แก้ไข ${type}`,
    text: `คุณต้องการแก้ไขหน้า ${name} ใช่หรือไม่?`,
    showCancelButton: true,
    confirmButtonText: 'ใช่',
    confirmButtonColor: '#7367f0',
    cancelButtonText: 'ไม่',
  }).then((result) => {
    if (result.isConfirmed) {
      window.open(`${ROUTE_HIS}/designer/${designerType}/${code}`, '_self')
    }
  })
}

const errorNoti = (message) => {
  const notice = PNotify.error({
    title: 'บันทึกไม่สำเร็จ',
    text: message,
    icon: 'fas fa-exclamation-circle fa-xl',
  })
  notice.on('click', function () {
    notice.close()
  })
}
